import { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage } from './popups'
import { basicSlider, testimonialSlider, newsSlider, quoteSlider, gallerySlider, slideSlider, prepSlider, historySlider, historySliderThumbs } from './sliders';
import { linksCustomization, scrollTo, responsiveTables, buttonSpans, copyLink, cookieYesSnippet } from './misc';
import setScrollBarWidth from 'set-scrollbar-width';  // Use with the Tailwind Container Break Out extension.
import scrollAnimations from './scrollAnimations';
/* Preloader */
import preloader from './preloader';

// Work with us
import workWithUs from './work-with-us';
import admissionsProcess from './admissions-process';

// Menu 
import menu from '../../templates/parts/menu';

/* Flexible Content */
import accordion from '../../templates/blocks/accordion';
import parallaxStats from '../../templates/blocks/stats-and-text';
import exploreMore from '../../templates/blocks/explore-more';
import scrollVideo from './scrollVideo';

// Tabs
import tabs from './tabs';


function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){	
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}



/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function() {
	// Init
	if(!document.querySelector('body').classList.contains('page-template-home')) {
		scrollAnimations();
	}
	
	consoleMessage()
	usingJS()
	setScrollBarWidth()
	linksCustomization()
	scrollTo()
	responsiveTables()
	preloader()
	buttonSpans()
	copyLink()
	
	
	// Menu
	menu();

	// Popups
	magnificPopupIframe()
	magnificPopupInline()
	magnificPopupSingleImage()
	magnificPopupGalleryImage()

	// Sliders
	basicSlider()
	testimonialSlider()
	newsSlider()
	quoteSlider()
	gallerySlider()
	slideSlider()
	prepSlider()
	historySlider()


	// Flexible Content
	accordion()
	parallaxStats()
	exploreMore();
	scrollVideo();
	workWithUs();
	tabs();
	admissionsProcess();

	cookieYesSnippet()
}


jQuery(document).ready(function ($) {
	ajax: {
		/**
		 * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
		 */
		$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
			magnificPopupIframe()
			magnificPopupInline()
			magnificPopupSingleImage()
			magnificPopupGalleryImage()
		});
	}
});

